import { Autocomplete, Badge, Box, Card, Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import React from 'react';
import CommonQuillEditor from 'common/editor';
import { capitalizeText } from 'utilities/common';
import SmartToyIcon from '@mui/icons-material/SmartToy'; // AI robot icon
export default function StiloAddEditStrain(props) {
  const { formData, setFormData, handleInputChange, errors, infoEffectData, strainId, productSlugData, handleChangeSlug, handleGenerate, isPromptLoading, infoEffectArr, flavors, onChangeCheckbox } = props
  return (
    <>
      <Grid container spacing={2.5} mb={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <TextField
            label='Strain Name*'
            value={formData.strainName}
            fullWidth
            variant='outlined'
            onChange={handleInputChange}
            name='strainName'
            error={Boolean(errors?.strainName)}
            helperText={errors?.strainName}
          />
        </Grid>       
        <Grid item xs={12} sm={6} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Strain Category*</InputLabel>
            <Select
              className='form-select'
              error={Boolean(errors?.strainCategory)}
              onChange={handleInputChange} label='Strain Category*' name='strainCategory' value={formData.strainCategory}>
              {
                infoEffectData?.map((infoStrain => {
                  return <MenuItem key={infoStrain.strainType} value={infoStrain.strainType}>{infoStrain?.strainType}</MenuItem>;
                }))
              }
            </Select>
            {Boolean(errors?.strainCategory) && <FormHelperText error>{errors?.strainCategory}</FormHelperText>}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            className="form-input"
            fullWidth
            label="Strain Slug"
            name="subStrainSlug"
            value={productSlugData}
            onChange={handleChangeSlug}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Meta Properties</Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="body2" fontWeight="medium" color="secondary">
              Generate Meta Content
            </Typography>

            <MDButton
              variant="contained"
              color="primary"
              size="small"
              onClick={handleGenerate}
              disabled={isPromptLoading || !formData?.strainName}
              startIcon={!isPromptLoading && <SmartToyIcon />} // Show icon only when not loading
            >
              {isPromptLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                'Generate'
              )}
            </MDButton>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            label="Meta Title*"
            className="form-input"
            fullWidth
            placeholder="Meta Title"
            value={formData?.metaTitle || ''}
            onChange={(e) => setFormData({ ...formData, metaTitle: e.target.value })}
            error={Boolean(errors?.metaTitle)}
            helperText={errors?.metaTitle}
          />
          <span className='drag_drop'>
            Character Count: {formData?.metaTitle?.length || 0} <span>(Recommended Characters: 60)</span>
          </span>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            label="Meta Description*"
            className="form-input"
            fullWidth
            placeholder="Meta Description"
            value={formData?.metaDescription || ''}
            onChange={(e) => setFormData({ ...formData, metaDescription: e.target.value })}
            error={Boolean(errors?.metaDescription)}
            helperText={errors?.metaDescription}
          />
          <span className='drag_drop'>
            Character Count: {formData?.metaDescription?.length || 0} <span>(Recommended Characters: 160)</span>
          </span>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Body Content</Typography>
          <Box>
            <TextField
              label='Heading (H1)*'
              fullWidth
              variant='outlined'
              value={formData?.strainHeading || ''}
              onChange={(e) => setFormData({ ...formData, strainHeading: e.target.value })}
              className='form-input'
              error={Boolean(errors?.strainHeading)}
              helperText={errors?.strainHeading}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Body Text*</Typography>
          <div className="remove-quill-mb">
            <CommonQuillEditor
              allowHeading={false}
              style={true} height={"300px"}
              value={formData?.description || ''}
              onChange={(value) => setFormData({ ...formData, description: value })}
            />
            {Boolean(errors?.description) && <FormHelperText error>{errors?.description}</FormHelperText>}
          </div>
        </Grid>
        <Grid item xs={12}>
          {
            infoEffectArr?.length ? <>
              <Stack direction='row' flexWrap='wrap' gap={2} sx={{ backgroundColor: '#F1F1F1' }} px={2.5} py={2} borderRadius={4}>
                {
                  infoEffectArr?.map((item, index) => {
                    const { title } = item;
                    const capatlizedTitle = capitalizeText(title);
                    let value = formData?.infoEffects?.includes(title);
                    return <FormControlLabel
                      key={index}
                      className='form-chip-checkbox'
                      control={<Checkbox checked={value} />}
                      label={capatlizedTitle}
                      onChange={(e) => onChangeCheckbox(e, title)}
                    />;
                  })
                }
              </Stack>
            </>
              :
              null
          }
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            id='tags-outlined'
            options={flavors || []}
            getOptionLabel={(option) => option.flavorType}
            filterSelectedOptions
            onChange={(val, selectedOption) => {
              setFormData({ ...formData, flavors: selectedOption });
            }}
            value={formData?.flavors}
            renderInput={(params) => (
              <TextField
                {...params}
                error={Boolean(errors?.flavors)}
                helperText={errors?.flavors}
                label='Flavours'
                placeholder='Categories'
              />
            )}
          />
          {Boolean(errors?.flavors) && <FormHelperText error>{errors?.flavors}</FormHelperText>}
        </Grid>
      </Grid>
    </>

  );
}